export const useMainMenuStore = defineStore('mainMenu', {
  state: () => ({
    leakProfile: null as LeakProfile|null,
  }),
});
